/*
 * Adds one visual-scoping class to Shopify's asynchronously injected privacy
 * banner. Shopify retains its original DOM, controls, events and consent API.
 */
(() => {
  const BANNER_ID = 'shopify-pc__banner';
  const ENHANCEMENT_CLASS = 'lps-shopify-privacy-banner';

  const enhance = (banner) => {
    if (!(banner instanceof HTMLElement) || banner.id !== BANNER_ID) return;
    banner.classList.add(ENHANCEMENT_CLASS);
  };

  const findAndEnhance = (root = document) => {
    if (root instanceof HTMLElement && root.id === BANNER_ID) {
      enhance(root);
      return;
    }

    enhance(root.querySelector?.(`#${BANNER_ID}`));
  };

  const initialise = () => {
    findAndEnhance();

    // Shopify injects (and can recreate) the banner after its privacy API loads.
    // Observing additions keeps the visual class attached without intercepting
    // any consent button or preference-modal behaviour.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) findAndEnhance(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
